export const classic_coords = (size) => ({
  xcoords: [1, 2, 3, 4, 5, 6, 7, 8].slice(0, size),
  ycoords: ["A", "B", "C", "D", "E", "F", "G", "H"].slice(0, size),
})

export const make_radar = (width, height, ships) => {
  let m = Array(height)
    .fill()
    .map(() =>
      Array(width)
        .fill()
        .map(() => ({
          containes_ship: false,
          status: "",
        }))
    )
  ships.forEach((ship) => {
    if (ship.dir === "h")
      for (let offset = 0; offset < ship.len; offset++)
        m[ship.pos.y][ship.pos.x + offset].containes_ship = true
    else
      for (let offset = 0; offset < ship.len; offset++)
        m[ship.pos.y + offset][ship.pos.x].containes_ship = true
  })

  return m
}

export const shipMargin = (s) => ({
  margin: `calc(${s.pos.y} * 100% / var(--grid-size)) calc(${s.pos.x} * 100% / var(--grid-size))`,
})
